// src/pages/Departments/MSGRYojana.js
export default function MSGRYojana() {
  return (
    <div>
      <h2>म.रा.रो. हमी योजना विभाग</h2>
      <p>
        ग्रामीण रोजगार हमी योजना, कामांची नोंद, मंजुरी व
        रोजगार निर्मितीच्या उपक्रमांचे व्यवस्थापन.
      </p>
    </div>
  );
}
